import React, {Component} from 'react'


class Product extends Component {
    state = {};

    render() {
        return <div className="card" data-testid="product">
            <a href={this.props.detailsURL} target="_blank">
                <img src={this.props.image}
                     onError={(e) => {
                         e.target.src = './assets/images/not_yet_available.jpg'
                         // e.target.style = 'padding: 8px; margin: 16px; filter: brightness(200%)'
                     }}
                     className="card-img-top" alt="..."/>
            </a>
            <div className="card-body">
                <a href={this.props.detailsURL} target="_blank">
                    <span data-testid="item-name" className={(this.props.itemname.length >= 20) ? "card-title-small" : "card-title"}>{this.props.itemname}</span>
                </a>

                <table className="table card-info" border="true">
                    <tbody>
                    <tr>
                        <td>Company:</td>
                        <td data-testid="item-company">{this.props.company}</td>
                    </tr>
                    <tr>
                        <td>Category:</td>
                        <td data-testid="item-category">{this.props.category}</td>
                    </tr>
                    <tr>
                        <td>Value:</td>
                        <td data-testid="item-value">{this.props.price}</td>
                    </tr>
                    </tbody>

                </table>
                {/*<button onClick={this.onDetails} className="btn btn-primary">Details</button>*/}
            </div>
        </div>
    }
}

export default Product;
